import { render, staticRenderFns } from "./BlockReport.vue?vue&type=template&id=7887bd45"
import script from "./BlockReport.vue?vue&type=script&lang=js"
export * from "./BlockReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports